import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';

import { SharedModule } from '../shared/shared.module';
import { PaymentModule } from '../payment/payment.module';
import { HomeSharedModule } from '../home-shared/module';

import { PricingComponent } from './component';
import { from } from 'rxjs';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: PricingComponent
      }
    ]),

    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatExpansionModule,

    SharedModule,
    PaymentModule,
    HomeSharedModule
  ],
  declarations: [
    PricingComponent,
  ]
})
export class PricingModule { }
